import React from 'react';
import { ButtonGroup, Button } from '@nextui-org/react';

const HousingMetricSelector = ({ selectedView, setSelectedView }) => {
  return (
    <div className="mb-4 flex justify-center">
      <ButtonGroup>
        <Button
          style={{
            backgroundColor: selectedView === 'us' ? '#245BA9' : 'transparent',
            borderColor: '#245BA9',
            color: selectedView === 'us' ? 'white' : '#245BA9'
          }}
          onClick={() => setSelectedView('us')}
        >
          CT vs. US
        </Button>
        <Button
          style={{
            backgroundColor: selectedView === 'northeast' ? '#245BA9' : 'transparent',
            borderColor: '#245BA9',
            color: selectedView === 'northeast' ? 'white' : '#245BA9'
          }}
          onClick={() => setSelectedView('northeast')}
        >
          CT vs. Northeast
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default HousingMetricSelector;